import React, { useEffect, useState } from 'react';
import TablaLecturas from './TopLectoresGlobalNew.tsx';

export default function FetchLecturas({ url , provParam = ''}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!url) return;

    const ctrl = new AbortController();
    const signal = ctrl.signal;

    async function load() {
      setLoading(true);
      setError(null);

      try {
        const res = await fetch(url, { method: 'GET', signal });
        if (!res.ok) {
          throw new Error(`HTTP ${res.status} - ${res.statusText}`);
        }
        const json = await res.json();

        // validación básica: esperar que sea un objeto con keys de usuarios
        if (json && typeof json === 'object') {
          setData(json);
        } else {
          throw new Error('Formato de JSON inesperado (se esperaba un objeto).');
        }
      } catch (err) {
        if (err.name === 'AbortError') {
          // fetch abortado, no hacemos nada
          return;
        }
        setError(err.message || String(err));
      } finally {
        setLoading(false);
      }
    }

    load();

    return () => ctrl.abort();
  }, [url]);

  // Render ligero: loading / error / tabla
  if (loading) return <div className="p-4">Cargando datos…</div>;
  if (error) return (
    <div className="p-4 text-red-600">
      Error al cargar datos: {error}
      <div className="text-sm text-gray-600 mt-2">
        Nota: si ves un error de CORS (Cross-Origin), asegúrate de que el bucket S3 tenga habilitado CORS público o usa un proxy en el servidor.
      </div>
    </div>
  );

  return (
    <div className="p-4">
      <TablaLecturas data={data} prov={provParam} />
    </div>
  );
}
